import React, { useContext, useState, useEffect } from 'react';
import { CourseDesignContext } from '../context/CourseDesignContext';
import './QuestionDayPicker.css';

const QuestionDayPicker = () => {
  const { courseDesignState, handleChange } = useContext(CourseDesignContext);
  const [items, setItems] = useState([]);

  useEffect(() => {
    // make a list of all of the items in the state with a dataType of either topic or sectionName
    setItems(
      courseDesignState.filter(
        item => item.dataType === 'topic' || item.dataType === 'sectionName'
      )
    );
  }, [courseDesignState]);

  const handleQuestionToggle = (dataID, currentStatus) => {
    const questionOptions = currentStatus === 'yes' ? 'no' : 'yes';

    const currentItem = items.find(item => item.dataID === dataID);
    const currentDataText = currentItem ? currentItem.dataText : '';

    handleChange('topic', dataID, currentDataText, { questionOptions });
  };

  const handleSyllabusToggle = (dataID, currentStatus) => {
    const questionLogic = currentStatus === 'yes' ? 'no' : 'yes';

    const currentItem = items.find(item => item.dataID === dataID);
    const currentDataText = currentItem ? currentItem.dataText : '';

    handleChange('topic', dataID, currentDataText, { questionLogic });
  };

  const handleSelectAllQuestions = () => {
    items
      .filter(item => item.dataType === 'topic')
      .forEach(item => {
        handleChange('topic', item.dataID, item.dataText, { questionOptions: 'yes' });
      });
  };

  const handleUnselectAllQuestions = () => {
    items
      .filter(item => item.dataType === 'topic')
      .forEach(item => {
        handleChange('topic', item.dataID, item.dataText, { questionOptions: 'no' });
      });
  };

  const handleSelectAllSyllabus = () => {
    items
      .filter(item => item.dataType === 'topic')
      .forEach(item => {
        handleChange('topic', item.dataID, item.dataText, { questionLogic: 'yes' });
      });
  };

  const handleUnselectAllSyllabus = () => {
    items
      .filter(item => item.dataType === 'topic')
      .forEach(item => {
        handleChange('topic', item.dataID, item.dataText, { questionLogic: 'no' });
      });
  };

  return (
    <div className="question-day-picker">
      <div className="picker-description">
        <p>
          All of the questions students answer will be associated with specific days of the course. Here you can pick which days will have questions associated with them. If you are displaying a syllabus on the site, you can also pick which days of the syllabus will have content (like readings, handouts, or links) associated with them.
        </p>
      </div>
      
      <div className="picker-content">
        <div className="picker-table-container">
          <table className="day-picker-table">
            <thead>
              <tr>
                <th>Course Day</th>
                <th>Has Questions</th>
                <th>Has Syllabus Links</th>
              </tr>
            </thead>
            <tbody>
              {items
                .sort((a, b) => a.dataIndex - b.dataIndex)
                .map(item => (
                  <tr key={item.dataID} className={item.dataType === 'sectionName' ? 'section-row' : 'topic-row'}>
                    <td className="day-name">
                      {item.dataText || 'Untitled'}
                    </td>
                    <td className="checkbox-cell">
                      {item.dataType === 'topic' ? (
                        <input
                          type="checkbox"
                          checked={item.questionOptions === 'yes'}
                          onChange={() => handleQuestionToggle(item.dataID, item.questionOptions)}
                          className="day-checkbox"
                        />
                      ) : (
                        <span>—</span>
                      )}
                    </td>
                    <td className="checkbox-cell">
                      {item.dataType === 'topic' ? (
                        <input
                          type="checkbox"
                          checked={item.questionLogic === 'yes'}
                          onChange={() => handleSyllabusToggle(item.dataID, item.questionLogic)}
                          className="day-checkbox"
                        />
                      ) : (
                        <span>—</span>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        
        <div className="action-buttons-container">
          <button 
            className="action-button questions-button" 
            onClick={handleSelectAllQuestions}
          >
            Select All Days for Questions
          </button>
          <button 
            className="action-button questions-button" 
            onClick={handleUnselectAllQuestions}
          >
            Unselect All Days for Questions
          </button>
          <button 
            className="action-button syllabus-button" 
            onClick={handleSelectAllSyllabus}
          >
            Select All Days for Syllabus Links
          </button>
          <button 
            className="action-button syllabus-button" 
            onClick={handleUnselectAllSyllabus}
          >
            Unselect All Days for Syllabus Links
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestionDayPicker;
